// import { ProgrammeApi, Configuration } from "../generated";
// import { fetchApi } from "./ApiErrorFetch";

import { ProgrammeService } from "../generated";

// const Programme = new ProgrammeApi(
//   new Configuration({ basePath: window.location.origin, fetchApi: fetchApi })
// );

export default ProgrammeService;
